import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=5920805b&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5920805b')) {
      api.createRecord('5920805b', component.options)
    } else {
      api.reload('5920805b', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=5920805b&", function () {
      api.rerender('5920805b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Cw9q0kjUAE7z/JS/comp/ImgFallback.vue"
export default component.exports